/** @module Specification/TrackingSampleRenderer */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,Ref,xml,Query) {
	return declare(Ref, {
		/**
		 * @override
		 * The custom store key is the PartMaterial's default quote
		 */
		getCustomStoreKey: function(ctx, h, bAll) {
			var quoteURL = ctx.getNode().BOMLineQuote;
			if (xml.isValidURL(quoteURL)){
				return quoteURL;
			} else {
				return null;
			}
		},

		/**
		 * @override
		 * Displays samples that has the same supplier as default quote
		 */
		_getStoreAction: function(ctx, h, bAll) {
			var partMaterial = ctx.getNode();
			var quoteSource = ctx.cache.getNode(partMaterial.BOMLineQuote).__Parent__;

			return lang.mixin(new Action(), {
				m_fixedQuery: new Query()
					.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, quoteSource),
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "ProductSamples",
					m_url: partMaterial.Actual
				})
			});
		}
	});
});